// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--3gSX0","TagBase":"TagBase--UgG1c","StatusBase":"StatusBase--2RnGx","Initial":"Initial--BNDRi","Analysing":"Analysing--3KP4k","Completed":"Completed--2tts4"};